<template>
  <div class="app app-project-task-mine v">
    <van-tabs v-model="current" class="flex v" border @click-tab="handleClickTab">
      <van-tab v-for="(s, k) in status" :key="k" :name="k" :title="s.name">
        <list :url="$route.query.type == 'my' ? '/api/proTask/my' : 'api/proTask'"
          :params="$route.query.type == 'my' ? { status: s.status } : { status: $route.query.status ? current=='ALL'?null:current : s.status, orders: [{ column: 's.order_index', asc: true }, { column: 'a.name', asc: true }], createTime: $route.query.createTime }"
          style="height: 100%;" :show-status="$route.query.status ? K === 'FINISH' : k === 'ALL'" />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import List from "./index";

export default {
  components: { List },
  data() {
    return {
      status: {
        ALL: { name: "全部", status: null },
        WAITTING: { name: "待开始", status: "WAITTING" },
        RUNING: { name: "进行中", status: "RUNING" },
        FINISH: { name: "已完成", status: "FINISH" },
        // CANCEL: { name: "已取消", status: "CANCEL" },
      },
      current: "ALL",
    };
  },
  methods: {
    handleClickTab(item) {
     
    },
},
  mounted() {
    if (this.$route.query.status) {
      this.current = this.$route.query.status
    } else {
      this.current = "ALL"
    }
  }
};
</script>

<style lang="scss">
.app-project-task-mine {
  .van-tabs {
    .van-tabs__wrap {
      flex: 0 0;
      flex-basis: initial;
    }

    .van-tabs__content {
      flex: 1;

      .van-tab__pane {
        height: 100%;
        position: relative;

        .van-pull-refresh {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>